import React from 'react';
import { Outlet } from 'react-router-dom';
import AdminSidebar from '../Admin/AdminSidebar';
import { useUser } from '../Context/UserContext';
import '../Admin/Admin.css';

export default function AdminLayout() {
  const { userData } = useUser();

  return (
    <div className="admin-layout">
      <AdminSidebar />
      <div className="admin-main-content">
        <header className="admin-topbar">
            <h2 className="page-title">Dashboard</h2>
            <div className="topbar-actions">
                <a href="/" target="_blank" rel="noopener noreferrer" className="view-store-btn">
                    <ion-icon name="eye-outline"></ion-icon> View Store
                </a>
                <div className="user-profile">
                    <div className="avatar">{userData?.name?.charAt(0).toUpperCase() || 'A'}</div>
                    <span>Welcome, {userData?.name || 'Admin'}</span>
                </div>
            </div>
        </header>
        <main className="admin-content-wrapper">
            <Outlet />
        </main>
      </div>
    </div>
  );
}
